import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderingSelectors } from 'polygon-ordering';
import { useAppSelector } from '../app/hooks';
import MessageModal from '../components/atoms/MessageModal';
import { registerPresaleModalOpenSetter, closePresaleModal } from '../utils/presaleModalRef';

const { getSaleType, getLocationId } = OrderingSelectors;

const PresaleModal = () => {
  const { t } = useTranslation();
  const saleType = useAppSelector(getSaleType);
  const locationId = useAppSelector(getLocationId);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    registerPresaleModalOpenSetter(setIsOpen);
    return () => {
      registerPresaleModalOpenSetter(null);
    };
  }, []);

  if (!isOpen) {
    return null;
  }

  const title = t(`preSaleMessage.title.${saleType}`, { defaultValue: '' });
  const message = t(`preSaleMessage.message.${saleType}`, { defaultValue: '' });
  const hasValidMessage = title !== '' && message !== '';

  if (!hasValidMessage || !locationId) {
    return null;
  }

  return (
    <MessageModal
      title={title}
      message={message}
      handleClose={closePresaleModal}
      alertButtons={[{ text: t('button.continue'), action: closePresaleModal, isPreferred: true }]}
    />
  );
};

export default PresaleModal;
